<template>
	<div class="courseCenter bg-[#F5F7FA]">
		<Header :current="1"></Header>
		<div class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto mt-[15px] mb-[53px]">
			<div class="mb-[37px] bg-white rounded-b-md text-[14px] pt-[21px] pr-[30px] pb-[30px] pl-[45px] box-border">
				<div class="flex justify-between mb-[20px]">
					<div class="flex  pb-[20px] box-border">
						<div class=" text-[#1C1F21] font-bold h-[23px] leading-[23px] mr-[25px]">
							{{langInfo.class_screen}}
						</div>
					</div>
					<div class="flex justify-between bB-01 pb-[20px] box-border flex-1">
						<div @click="classAllClick(0)"
							:class="course_category_id==0?'text-white bg-[#2979FF] rounded-[50px]':''"
							class="w-[54px] h-[23px] cursor-pointer mb-[10px] mr-[10px] leading-[23px]  text-center   ">
							{{langInfo.class_all}}
						</div>
						<div class="text-[#4D4D4D] cursor-pointer flex-1 flex flex-wrap">
							<div :class="course_category_id==item.id?'text-white bg-[#2979FF] rounded-[50px]':''"
								@click="classClick(item,index)" v-for="(item,index) in courseClassList" :key="index"
								class="leading-[23px] px-[12px] box-border mb-[10px] mr-[18px]">
								{{item.name}}
							</div>
						</div>
					</div>
				</div>
			<!-- 	<div class="flex justify-between mb-[20px]">
					<div class="flex  pb-[20px] box-border">
						<div class=" text-[#1C1F21] font-bold  h-[23px] leading-[23px] mr-[25px]">
							{{langInfo.certificate_screen}}
						</div>
					</div>
					<div class="flex justify-between bB-01 pb-[20px] box-border flex-1">
						<div @click="certAllClick(0)"
							:class="certificate_id==0?'text-white bg-[#2979FF] rounded-[50px]':''"
							class="w-[54px] h-[23px] cursor-pointer leading-[23px] mb-[10px]  mr-[10px]  text-center  rounded-[50px]">
							{{langInfo.class_all}}
						</div>
						<div class="text-[#4D4D4D] flex-1 flex flex-wrap">
							<div @click="certClick(item,index)"
								:class="certificate_id==item.id?'text-white bg-[#2979FF] rounded-[50px]':''"
								v-for="(item,index) in certificateList" :key="index"
								class="leading-[23px] cursor-pointer mr-[18px] mb-[10px] px-[12px] box-border">
								{{item.name}}
							</div>
						</div>
					</div>
				</div> -->
				<div class="flex justify-between ">
					<div class="flex ">
						<div class=" text-[#1C1F21] font-bold h-[23px] leading-[23px] mr-[25px]">
							{{langInfo.subject_screen}}
						</div>
					</div>
					<div class="flex justify-between  flex-1">
						<div @click="subjectAllClick(0)"
							:class="subject_id==0?'text-white bg-[#2979FF] rounded-[50px]':''"
							class="w-[54px] h-[23px] cursor-pointer leading-[23px] mb-[10px] mr-[10px]  text-center  ">
							{{langInfo.class_all}}
						</div>
						<div class="text-[#4D4D4D] flex-1 flex flex-wrap">
							<div @click="subjectClick(item,index)"
								:class="subject_id==item.id?'text-white bg-[#2979FF] rounded-[50px]':''"
								v-for="(item,index) in subjectList" :key="index"
								class="leading-[23px] cursor-pointer mb-[10px] mr-[18px] px-[12px] box-border">
								{{item.name}}
							</div>
						</div>
					</div>
				</div>


			</div>
			<div class="text-[14px] mb-[15px] flex items-center justify-between">
				<label class=" text-[#101010]">{{langInfo.study_total}}：{{total}}{{langInfo.product_a_baby}}</label>
				<div class="flex items-center cursor-pointer" @click="saleClick()">
					<label class="text-[#000000] mr-[10px] cursor-pointer">{{langInfo.sales}}{{saleText}}</label>
					<div class="flex flex-col items-center cursor-pointer">
						<img :src="saleSort=='asc'?imgAscActive:imgAsc" class="w-[16px] h-[9px] mb-[4px]" alt="" />
						<img :src="saleSort=='desc'?imgDesActive:imgDes" class="w-[16px] h-[9px]" alt="" />
					</div>
				</div>
			</div>
			<div class="2xl:columns-4 xl:max-w-7xl ">
				<div class="grid grid-cols-4 gap-[27px] mb-[40px]" ref="courseList">

					<router-link :to="{path:'/courseDetail',query: { id: item.id }}"
						class="mb-[30px] inline-block bg-white no-underline" v-for="(item,index) in courseList"
						:key="index">
						<div class="rounded-md">
							<div class="w-full  relative" :style="{height:height+'px'}">
								<el-image class="w-full h-full" :src="item.cover_img" fit="cover"></el-image>
							</div>
							<div class="px-2.5 box-border shadow-01">
								<div
									class="h-[80px] bB-02  pt-[4px] pb-[10px] box-border flex flex-col justify-between ">
									<div class="text-[#1C1F21] yw-text-cut-2 text-[14px]">
										{{item.name}}
									</div>
									<div class="text-[#1C1F21]">
										¥{{item.course_discount}}
									</div>
								</div>
								<div class="pt-[10px] pb-[14px] flex   items-center justify-between">
									<div class="flex   ">
										<img class="w-[16px] h-[16px] mr-[6px]" src="@/static/image/icon03.png" alt=""
											srcset="" />
										<label class="text-xs text-[#9199A1]">{{item.sales_volume}}
											{{langInfo.person_purchased}}</label>
									</div>
									<label class="text-xs text-[#9199A1]">{{item.study_count}}
										{{langInfo.people_learned}}</label>
								</div>
							</div>
						</div>
					</router-link>

					<emptyPage v-if="isFinish&&courseList.length==0" :title="langInfo.no_data_available">
					</emptyPage>
				</div>

			</div>
			<div class="flex justify-center" v-if="courseList.length>0">
				<el-pagination :page-size="pageSize" :total="total" :current-page="currentPage"
					@current-change="currentChange" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},
		data() {
			return {
				saleSort: 'asc', //asc升序   desc降序
				saleText: "", //从低到高
				imgAscActive: require('../../static/image/icon10Active.png'),
				imgAsc: require('../../static/image/icon10.png'),
				imgDesActive: require('../../static/image/icon11Active.png'),
				imgDes: require('../../static/image/icon11.png'),
				courseClassList: [],
				pageSize: 8, //每页显示条目个数
				total: 0,
				currentPage: 1,
				isFinish: false,
				courseList: [],
				name: '',
				course_category_id: '',
				certificateList: [], //证书列表
				certificate_id: '',
				subjectList: [], //科目列表
				subject_id: '',
				langInfo: {},

				width: 0,
				height: 0,
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log("监听课程中心==="); // 获取查询参数
				console.log(to.query.name);
				if (to.query.name) {
					this.name = to.query.name
				}
				if (to.query.course_category_id) {
					this.course_category_id = to.query.course_category_id
				}
				this.currentPage = 1
				this.total = 0
				this.isFinish = false
				this.get_product_list()
			}
		},
		mounted() {
			if (this.$route.query.name) {
				this.name = this.$route.query.name
			}
			if (this.$route.query.course_category_id) {
				this.course_category_id = this.$route.query.course_category_id
			}

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title = this.langInfo.pc_name+'-'+this.langInfo.head_class_nav

				if (this.saleSort == 'desc') {
					this.saleText = this.langInfo.sort_desc
				} else if (this.saleSort == 'asc') {
					this.saleText = this.langInfo.sort_asc
				}
			}





			this.isFinish = false

			this.get_category_list() //分类
			this.get_certificate_list() //证书列表
			this.get_subject_list() //科目列表
			this.get_product_list()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title = this.langInfo.pc_name+'-'+this.langInfo.head_class_nav

					if (this.saleSort == 'desc') {
						this.saleText = this.langInfo.sort_desc
					} else if (this.saleSort == 'asc') {
						this.saleText = this.langInfo.sort_asc
					}

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			get_category_list() {
				this.$api.category_list({

				}).then((res) => {
					console.log(res);
					this.courseClassList = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			get_certificate_list() {
				this.$api.certificate_list({

				}).then((res) => {
					console.log(res);
					this.certificateList = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			get_subject_list() {
				this.$api.subject_list({

				}).then((res) => {
					console.log(res);
					this.subjectList = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			classAllClick(id) {
				this.name = ""
				this.course_category_id = id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},
			classClick(item, index) {
				this.name = ""
				this.course_category_id = item.id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},

			// 证书
			certAllClick(id) {
				this.name = ""
				this.certificate_id = id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},
			certClick(item, index) {
				this.name = ""
				this.certificate_id = item.id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},
			// 科目
			subjectAllClick(id) {
				this.name = ""
				this.subject_id = id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},
			subjectClick(item, index) {
				this.name = ""
				this.subject_id = item.id
				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()
			},
			saleClick() {
				if (this.saleSort == 'asc') {
					this.saleSort = "desc"
					this.saleText = this.langInfo.sort_desc
				} else if (this.saleSort == 'desc') {
					this.saleSort = "asc"
					this.saleText = this.langInfo.sort_asc
				}

				this.currentPage = 1
				this.total = 0
				this.isFinish = false;
				this.get_product_list()

			},
			get_product_list() {
				var param = {
					page: this.currentPage,
					limit: this.pageSize,
					name: this.name,
					order_sales_volume: this.saleSort
				}
				if (this.course_category_id) {
					param.course_category_id = this.course_category_id
				}
				if (this.certificate_id) {
					param.certificate_id = this.certificate_id
				}
				if (this.subject_id) {
					param.subject_id = this.subject_id
				}


				this.$api.product_list(param).then((res) => {
					console.log("商品=====");
					console.log(res);

					this.courseList = res.data.data
					this.total = res.data.total
					this.isFinish = true

					this.width = this.$common.calculateWidthHeight(this.$refs.courseList.offsetWidth, 3, 2, 81, 4)
						.width
					this.height = this.$common.calculateWidthHeight(this.$refs.courseList.offsetWidth, 3, 2, 81, 4)
						.height

					console.log(this.height);

				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			currentChange(e) {
				console.log(e);
				this.currentPage = e
				this.get_product_list()
			},

		}
	}
</script>

<style>
	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li {
		background-color: #fff;
		border: 1px solid rgba(217, 217, 217, 1);
		border-radius: 5px;
		width: 32px;
		height: 32px;
		line-height: 32px;
		color: #101010;
		font-size: 14px;
		font-weight: 500;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		border: 1px solid #1990FF;
		background-color: #3894FF;
	}
</style>